module.exports = __webpack_public_path__ + "01_long_black.11383e56.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/01_long_black.png
// module id = gSwX
// module chunks = 0